import React from 'react'
import GlassEffect from '../GlassEffect/GlassEffect'
import MyButton from '../../../../../components/UI/button/MyButton'
import './style.scss'

export default function SliderCard({ animation, title, text, img, handleClick, source }) {


    return (
        <div className="landing-slider-card" onClick={() => handleClick(source)}>
            {img ?
                <img className="landing-slider-card__img" src={`${process.env.REACT_APP_BASENAME}/img/${img}`} alt='' /> : <div className="landing-slider-card-animation">
                    {animation}
                </div>}

            <div className="landing-slider-card-info">
                <h4>{title}</h4>
                <p>{text}</p>

                <MyButton buttonText={'Try it'} />
            </div>
        </div>
    )
}
